<form id="container">
  <p id="header">{{ "WHY_DO_YOU_WANT_TO_REPLACE_THE_DEVICE" | translate }}?</p>

  <mat-radio-group [(ngModel)]="form.deviceStatus" class="vertical-radio-group pb-3" name="replaceStatus">
    @for (option of options; track option) {
      <mat-radio-button [value]="option.value">
        <span class="radio-label">
          {{ option.label | translate }}
        </span>
      </mat-radio-button>
    }
  </mat-radio-group>

  @if (errorMsg) {
    <div class="alert alert-danger" role="alert">
      {{ errorMsg | translate }}
    </div>
  }

  <button type="submit" class="btn btn-primary ml-2" [disabled]="cancelling" (click)="replaceDevice()" [disabled]="replacing">
    @if (replacing && !cancelling) {
      <i class="fad fa-spinner-third fa-spin" style="margin-right: 7px"></i>
    }
    {{ ((replacing && !cancelling) ? "REPLACING" : "SAVE") | translate }}
  </button>

  <button class="btn secondaryBtnWhiteBg ml-2" (click)="cancel()">
    @if (cancelling) {
      <i class="fad fa-spinner-third fa-spin" style="margin-right: 7px"></i>
    }
    {{ (cancelling ? "CANCELLING" : "CANCEL") | translate }}
  </button>
</form>
